import React, { useImperativeHandle, forwardRef, useEffect, useRef, useState  } from "react";
import PropTypes from "prop-types";
import CollapsibleTable from "../../components/table/CollapsibleTable/CollapsibleTable";
import TableService from "../../services/tableService";
import { useTableFieldsConfig, TABLE_NAME } from "../InvoicingInvoicesPage/PageTableFieldsConfig";
import { useInvoices } from "../../services/bankingService";
import { useCallback, useMemo } from "react";
import FilterTable from "../../components/table/FilterTable";

const InnerInvoicingTable = React.memo(
  ({id,
    onClickCheck,
    hiddenColumnsForTables,
    columnsOrdersForTables,
    headersConfig,
   }) => {

    const TABLE_FIELDS_CONFIG = useTableFieldsConfig();

    const { data: invoiceData, refetch, isLoading } = useInvoices(new URLSearchParams({agreement: id, page_size: 100}));
    const [dataLocal, setDataLocal] = useState()

    useEffect(() => {
        if (invoiceData?.results) {
            setDataLocal(invoiceData.results);
        }
    }, [invoiceData]);

    const onClickButton = useCallback((e, id) => {
        e.stopPropagation();
    }, []);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                TABLE_FIELDS_CONFIG,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[TABLE_NAME]
                    : [], // @ts-ignore
                columnsOrdersForTables?.[TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[TABLE_NAME]
                    : [],
                onClickButton,
            ),
        [
            TABLE_FIELDS_CONFIG,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickButton,
        ],
    );

    const tableComponent = () => (
        <FilterTable
            // @ts-ignore
            data={data}
            withPagination={false}
            showCounterRecords={false}
            style={{ maxHeight: "60vh" }}
            headersConfig={headersConfig}
            showFilters={false}
            showCleanFilterIcon={false}
            showContextMenu={false}
            showExportToFileButton={false}
            showDetailsIcon={false}
            onClickCheck={onClickCheck}
            showCheckbox={false}
            hideFiltersIconCol={true}
            setDataLocal={setDataLocal}
            isLoading={isLoading}
            disableFilterCheckBox={true}
        />
    );

    return tableComponent()
   
  }
);

const  AgreementCollapsibleTable  = React.memo((props) => { 
  return (
    <CollapsibleTable
      showStatusColorCircle={false}
      checkedAll={props.checkedAll}
      showDetailsIcon={false}
      showFilters={false}
      showCheckbox={props.showCheckbox}
      data={props.data}
      unPreparedData={props.data}
      countRecords={props.countRecords}
      showCounterRecords={props.showCounterRecords}
      page={props.page}
      onPageChange={props.onPageChange}
      rowsPerPage={props.rowsPerPage}
      onRowsPerPageChange={props.onRowsPerPageChange}
      rowsPerPageOptions={props.rowsPerPageOptions}
      resetPageNumber={props.resetPageNumber}
      headersConfig={props.headersConfig}
      showCleanFilterIcon={true}
      CollapsibleElement={
        <InnerInvoicingTable 
        onClickCheck={props.onClickInnerTableCheckBox}
        headersConfig={props.innerTableHeadersConfig}
        columnsOrdersForTables={props.columnsOrdersForTables}
        hiddenColumnsForTables={props.hiddenColumnsForTables}
        />
      }
      selectedItemId={props.selectedTicketId}
      style={props.style}
      filterPrefix={props.filterPrefix}
      showExportToFileButton={props.showExportToFileButton}
      exportToFileUrl={props.exportToFileUrl}
      exportToFileSearchParams={props.exportToFileSearchParams}
      exportToFileHeaders={props.exportToFileHeaders}
      exportToFileFileName={props.exportToFileFileName}
      isLoading={props.isLoading}
      withPagination={props.withPagination}
    />
  );
});

AgreementCollapsibleTable.propTypes = {
  showDetailsIcon: PropTypes.bool,
  checkedAll: PropTypes.bool,
  onClickCheck: PropTypes.func,
  onClickCheckAll: PropTypes.func,
  onClickRow: PropTypes.func,
  showCleanFilterIcon: PropTypes.bool,
  is_closed: PropTypes.bool,
  data: PropTypes.array,
  filteringData: PropTypes.object,
  countRecords: PropTypes.number,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPageChange: PropTypes.func,
  rowsPerPage: PropTypes.number,
  onRowsPerPageChange: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  resetPageNumber: PropTypes.func,
  hiddenColumns: PropTypes.object,
  columnsOrders: PropTypes.object,
  style: PropTypes.object,
  filterPrefix: PropTypes.string,
  onClickInnerTableRow: PropTypes.func,
  showStatusColorCircle: PropTypes.func,
  showExportToFileButton: PropTypes.bool,
  exportToFileUrl: PropTypes.string,
  exportToFileSearchParams: PropTypes.object,
  exportToFileHeaders: PropTypes.array,
  exportToFileFileName: PropTypes.string,
};

AgreementCollapsibleTable.defaultProps = {
  hiddenColumns: {},
  columnsOrders: {},
  showDetailsIcon: false,
  showCleanFilterIcon: false,
  showStatusColorCircle: false,
};

export default AgreementCollapsibleTable;
